var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNifti(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 24,
    fill: "#7747F6",
    fillOpacity: 0.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.7773 36.1016H29.2227C31.6484 36.1016 32.8555 34.8711 32.8555 32.4336V21.793H24.3711C22.8711 21.793 22.1562 21.0781 22.1562 19.5781V10.9766H16.7773C14.3633 10.9766 13.1445 12.2188 13.1445 14.6562V32.4336C13.1445 34.8828 14.3516 36.1016 16.7773 36.1016ZM24.4062 20.1875H32.7148C32.6445 19.707 32.3047 19.2383 31.7422 18.6641L25.2852 12.0898C24.7344 11.5273 24.2539 11.1875 23.7617 11.1055V19.5547C23.7617 19.9766 23.9727 20.1875 24.4062 20.1875Z",
    fill: "#7747F6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNifti);
export default __webpack_public_path__ + "static/media/nifti.2c5dab4bcd72395441da96c430956d22.svg";
export { ForwardRef as ReactComponent };